export const setAuthToken = (token: string) => {
  sessionStorage.setItem('authToken', token);
};

export const getAuthToken = () => {
  return sessionStorage.getItem('authToken') || null;
};

export const clearAuthToken = () => {
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('isPatientSession');
  sessionStorage.removeItem('patientUuid');
  sessionStorage.removeItem('patientFirstName');
  sessionStorage.removeItem('patientLastName');
};

export const setPatientSession = (patientUuid: string, firstName?: string, lastName?: string) => {
  sessionStorage.setItem('isPatientSession', 'true');
  sessionStorage.setItem('patientUuid', patientUuid);
  if (firstName != null) sessionStorage.setItem('patientFirstName', firstName);
  if (lastName != null) sessionStorage.setItem('patientLastName', lastName);
};

export const getIsPatientSession = () => sessionStorage.getItem('isPatientSession') === 'true';
export const getPatientUuid = () => sessionStorage.getItem('patientUuid') || null;
export const getPatientFirstName = () => sessionStorage.getItem('patientFirstName') || '';
export const getPatientLastName = () => sessionStorage.getItem('patientLastName') || '';

export const AUTHORIZATION_HEADER_NAME = 'X-Authorization';
